<template>
    <div class="main-container px-5 py-5 xl:px-5">
        <ConfirmPopup></ConfirmPopup>
        <Toast />
        <div class="flex justify-start pb-6">
            <SelectButton  v-model="showing" optionValue="value" :options="showingOptions" optionLabel="label"
                dataKey="value" aria-labelledby="basic" />
            <InputText v-model="searchQuery" placeholder="Search campaigns..." class="ml-4" />
        </div>
        <UnmappedCampaigns v-if="showing === 'unmapped'" :search-query="searchQuery" />
        <MappedCampaigns v-else :search-query="searchQuery" />
    </div>
</template>

<script setup>
import { ref, onMounted, reactive, watch, computed } from "vue";
import { useRoute, useRouter } from 'vue-router';
import UnmappedCampaigns from "./UnmappedCampaigns.vue";
import MappedCampaigns from "./MappedCampaigns.vue";

const route = useRoute();
const router = useRouter();

const showingOptions = ref([
    { label: 'Unmapped Campaigns', value: 'unmapped' },
    { label: 'Mapped Campaigns', value: 'mapped' }]);

// Seeded from the URL so a mapping worklist can link straight to a tab and a
// search, and so the page survives a refresh or a shared link.
const showing = ref(route.query.showing === 'mapped' ? 'mapped' : 'unmapped');
const searchQuery = ref(typeof route.query.q === 'string' ? route.query.q : '');

// Mirror state back into the URL. replace, not push, so toggling the tab or
// typing in the search box doesn't bury the previous page in history.
watch([showing, searchQuery], ([view, q]) => {
    const query = { ...route.query };
    if (view === 'mapped') query.showing = 'mapped'; else delete query.showing;
    if (q) query.q = q; else delete query.q;
    router.replace({ query });
});
</script>

<style scoped>

</style>